module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_8-min.c219f4b8.jpg";